import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useEmployeeIdStore from "../../store/useEmployeeIdStore";
import useAllPermissionsStore from "../../store/useAllPermissionsStore";
import useEmployeePermissionsStore from "../../store/useEmployeePermissionsStore";

const EditEmployeePermissions = () => {
  const accessToken = localStorage.getItem("accessToken");
  const navigate = useNavigate();
  const { eachEmployeeInfo, clearEmployeeInfo } = useEmployeeIdStore();
  const { permissions, fetchPermissions } = useAllPermissionsStore();
  const { employeePermissions, fetchEmployeePermissions } = useEmployeePermissionsStore();
  
  const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchPermissions();
  }, []);

  useEffect(() => {
    if (!eachEmployeeInfo) {
      navigate("/permissionmanagement");
    }
  }, [eachEmployeeInfo, navigate]);

  useEffect(() => {
    if (eachEmployeeInfo?.id) {
      fetchEmployeePermissions(eachEmployeeInfo.id);
    }
  }, [eachEmployeeInfo?.id]);

  useEffect(() => {
    if (employeePermissions && employeePermissions.length > 0) {
      const employeePermissionIds = employeePermissions.map(emp => emp.id);
      setSelectedPermissionIds(employeePermissionIds);
    }
  }, [employeePermissions]);

  const isPermissionSelected = (permissionId) => {
    return selectedPermissionIds.includes(permissionId);
  };

  const handleCheckboxChange = (permissionId) => {
    setSelectedPermissionIds(prev => {
      if (prev.includes(permissionId)) {
        return prev.filter(id => id !== permissionId);
      } else {
        return [...prev, permissionId];
      }
    });
  };

  const handleUpdate = async () => {
    setIsLoading(true);
    
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${accessToken}`);
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "permission_ids": selectedPermissionIds
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/employees/${eachEmployeeInfo.id}/permissions`,
        requestOptions
      );
      const result = await response.text();
      // console.log(result);
      
      if (response.ok) {
        alert("Permissions updated successfully!");
       
        navigate("/permissionmanagement");
      }
    } catch (error) {
      console.error("Error updating permissions:", error);
      alert("Error updating permissions. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {  
    clearEmployeeInfo();
    navigate("/permissionmanagement");
  };

  
  if (!eachEmployeeInfo) {
    return (
      <div className="w-full p-7">
        <div className="flex items-center justify-center h-64">
          <div className="text-lg text-gray-600">Loading...</div>
        </div>
      </div>
    );
  }

  const employeeName = eachEmployeeInfo?.employee_full_name || "N/A";
  const employeeId = eachEmployeeInfo?.employee_id || "N/A";
  const companyName = eachEmployeeInfo?.roles?.[0]?.company?.[0]?.company_name || "N/A";
  const roleName = eachEmployeeInfo?.roles?.[0]?.role_name || "N/A";

  // console.log("individual employee info", eachEmployeeInfo);
  // console.log("employee permissions", employeePermissions);
  // console.log("selected permission ids", selectedPermissionIds);

  return (
    <div className="w-full p-7">
      <div className="flex">
        <div className="flex items-center gap-8">
          <div className="flex items-center">
            <button
              onClick={handleBack}
              className="flex items-center text-2xl text-primary-hrms font-medium"
            >
              <i className="ri-arrow-left-s-line"></i>
              BACK
            </button>
          </div>
          <div>
            <h1 className="text-2xl font-medium text-medium-dark-gray">
              Edit Role Management
            </h1>
          </div>
        </div>
      </div>

      <div className="bg-white mt-10">
        <div className="role_mgmt_view-firstRow">
          <div>
            <div className="role_mgmt-titles">
              <h6>Employee Name:</h6>
              <p>{employeeName}</p>
            </div>
            <div className="role_mgmt-titles">
              <h6>Employee Id:</h6>
              <p>{employeeId}</p>
            </div>
          </div>
          <div>
            <div className="role_mgmt-titles">
              <h6>Company:</h6>
              <p>{companyName}</p>
            </div>
            <div className="role_mgmt-titles">
              <h6>Position:</h6>
              <p>{roleName}</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="mt-8">
        <h5 className="p-2.5 text-[18px] font-semibold bg-[#ecfdf3] text-medium-dark-gray">
          Permissions
        </h5>
        <div className="role_management-container">
          {permissions?.map((permission) => (
            <div
              key={permission.permission_id}
              className="role_management-lists"
            >
              <div className="role_management-list">
                <input
                  type="checkbox"
                  name="permissions[]"
                  checked={isPermissionSelected(permission.permission_id)}
                  onChange={() => handleCheckboxChange(permission.permission_id)}
                />
                <p>{permission.name}</p>
              </div>
              <hr />
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-end">
        <button 
          onClick={handleUpdate}
          disabled={isLoading}
          className="bg-primary-hrms text-white py-2 px-4 rounded-md hover:bg-green-800 disabled:opacity-50"
        >
          {isLoading ? "Updating..." : "Update"}
        </button>
      </div>
    </div>
  );
};

export default EditEmployeePermissions;